<template>
  <nav>
    <div class="nav-links" />
    <div class="nav-contact">
      <div class="nav-item email">
        <a href="mailto:eugene@builtbyeugene.com">eugene@builtbyeugene.com</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "navigation",
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav,
.nav-links,
.nav-contact {
  display: flex;
}
nav {
  justify-content: space-between;
  font-size: 12px;
  min-height: 40px;
  margin: 10px;
}

a {
  color: #ababab;
  text-decoration: none;
  text-transform: uppercase;
  user-select: none;
  font-weight: 600;

  transition: all 0.5s ease;
}

.links a:hover {
  transform: scale(1.1);
  color: #e89a9d;
  font-weight: 600;
}

.email a {
  font-weight: 400;
  text-transform: none;
  transition: all 0.2s ease;
}
.email a:hover {
  color: #e89a9d;
}

.nav-item {
  display: flex;
  align-items: center;
  text-align: left;
  color: #ababab;
  /* padding: 20px; */
  min-width: 80px;
}

@media all and (max-width: 700px) {
  .nav-item {
    min-width: 100%;
    padding: 0px;
  }
}
</style>
